import { H2, P } from '@ahmdigital/ui';
import { isValidElement, ReactElement, ReactNode } from 'react';
import { map } from 'lodash/fp';

import { StyledList, StyledSection } from '../../../styles';
import uncapFpIterator from '../../../../../../utils/uncap-fp-iterator';

type Content = string | ReactNode;

type List = {
  children: Content[];
  isOrdered?: boolean;
};
type BodyContent = Content | List;

type Props = {
  heading?: Content;
  body?: BodyContent[];
};

const mapWithIndex = uncapFpIterator(map);
const getIsList = (content: BodyContent): content is List => (content as List).children !== undefined;
const isReactElement = (content: unknown): content is ReactElement => isValidElement(content);

const ContentBlock = ({ heading, body }: Props) => (
  <StyledSection>
    {heading && (
      <H2 looksLike="h4" variant="marginBottomSpacer10">
        {heading}
      </H2>
    )}
    {body &&
      // @ts-expect-error - Automatic, Please fix when editing this file
      mapWithIndex((content, index) => {
        if (getIsList(content)) {
          return (
            <StyledList isOrdered={content.isOrdered || false} key={index}>
              {mapWithIndex(
                // @ts-expect-error - Automatic, Please fix when editing this file
                (child, childIndex) => (
                  <li key={childIndex}>{child}</li>
                ),
                content.children,
              )}
            </StyledList>
          );
        }
        if (isReactElement(content)) {
          return content;
        }
        return <P>{content}</P>;
      }, body)}
  </StyledSection>
);

export default ContentBlock;
